var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BQdtCard',{attrs:{"name":"complaintsRatingsHelp","type":"help"}})
}
var staticRenderFns = []

export { render, staticRenderFns }